import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  Typography,
  Snackbar,
  Alert,
  Grid,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import style from "../../../styles/brsr/general.module.css";
import EastIcon from "@mui/icons-material/East";
import { validatePercentage } from "../../../utils/validateFields";
import DeleteRowDialog from "../../Common/DeleteRowDialog";
import { numberError } from "../../../utils/validationMessage";
import { api, get, put } from "../../../utils/api";
import DynamicTable from "../../Common/DynamicTable";
import { validateTable } from "../../../utils/validateTable";
import { restructureData } from "../../../utils/restructureData";
import { useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../utils/companyId";
import ReviewBox from "../../Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";
import BRSRFile from "../../Common/BRSRFile";

const inputData = [
  {
    fieldName: "associatedCompaniesAndCsr",
    title: "23. Names of Holding/Subsidiary/Associate Companies/Joint Ventures",
    type1: "array",
    fields: [
      {
        fieldName: "name",
        title:
          "Name of the holding / subsidiary / associate companies / joint ventures (A)",
        placeholder: "Enter Text",
        type: "text",
        width: "13rem",
      },
      {
        fieldName: "relationType",
        title: "Indicate whether holding/Subsidiary/Associate/Joint Venture",
        placeholder: "Enter Text",
        type: "text",
        width: "17rem",
      },
      {
        fieldName: "sharePercentage",
        title: "% of shares held by listed entity",
        placeholder: "%",
        type: "percentage",
        width: "10rem",
      },
      {
        fieldName: "participatesInBR",
        title:
          "Does the entity indicated at column A, participate in the Business Responsibility initiatives of the listed entity? (Yes/No)",
        options: ["Yes", "No"],
        type: "select",
        width: "15rem",
      },
    ],
  },
];

const Holdings = ({ onSave, hide, removeUpload = false }) => {
  const { id } = useParams();
  const [modalupload, setModalUpload] = useState({
    associatedCompaniesAndCsrDoc: false,
    csrDetailsDoc: false,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const [tables, setTables] = useState(
    // inputData.map((section) => ({ fieldName: section.fieldName, rows: [{}] }))
    []
  );
  const [data, setData] = useState({});

  const [tabErrors, setTabErrors] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [errors, setErrors] = useState({
    turnover: "",
    netWorth: "",
  });

  const [csrApplicable, setCsrApplicable] = useState("Yes");
  const [disabled, setDisabled] = useState(false);

  const [formData, setFormData] = useState({
    applicable: "No",
    turnover: "",
    netWorth: "",
  });

  const [formData1, setFormData1] = useState({});

  const type = "SectionA";

  // Fetch existing data if ID is present
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/brsr/get?type=SectionA&id=${id}`);
        const res1 = response?.data?.data?.BRSRSectionA?.holding;
        setFormData1(res1);
        setData(res1);
        if (
          response?.data?.data?.year
            ? response?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);
        if (response?.data?.data) {
          const applicableValue = res1.csrDetails?.applicable ? "Yes" : "No";
          setFormData((prev) => ({
            ...prev,
            applicable: applicableValue,
            turnover: res1.csrDetails?.turnover ?? "",
            netWorth: res1.csrDetails?.netWorth ?? "",
          }));
          setCsrApplicable(applicableValue);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id, type]);

  const handleCsrInputChange = (field, value) => {
    if (!/^\d*\.?\d*$/.test(value)) return;
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error messages on change
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const isCsrApplicable = csrApplicable === "Yes";

    if (isCsrApplicable) {
      if (formData.turnover === "") {
        newErrors.turnover = "Turnover is required.";
      } else if (isNaN(formData.turnover)) {
        newErrors.turnover = numberError;
      } else if (formData.turnover < 0) {
        newErrors.turnover = numberError;
      }

      // Validate netWorth
      if (formData.netWorth === "") {
        newErrors.netWorth = "Net Worth is required.";
      } else if (isNaN(formData.netWorth)) {
        newErrors.netWorth = numberError;
      } else if (formData.netWorth < 0) {
        newErrors.netWorth = numberError;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    // if (!validateForm()) return;
    if (!disabled) {
      let isTableValid = validateTable(inputData, tables, setTabErrors);
      const isFormValid = validateForm();

      if (!isFormValid || !isTableValid) {
        return;
      }

      const updatedData = {
        holding: {
          ...restructureData(tables),
          csrDetails: {
            applicable: csrApplicable === "Yes",
            turnover: Number(formData.turnover) || 0,
            netWorth: Number(formData.netWorth) || 0,
          },
          // ...formData1,
        },
        holdingSubmitted: true,
        type: "SectionA",
      };

      try {
        // Send PUT request to the backend API
        const res = await put(`${api}/brsr/update?id=${id}`, updatedData);

        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        onSave();
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.response?.data?.message || "An error occurred",
          severity: "error",
        });
      }
    } else onSave();
  };

  const handleUploadDocument = (key) => {
    setModalUpload((prev) => ({
      ...prev,
      [key]: true,
    }));
    setOpen(true);
  };

  return (
    <Box>
      <p className={style.subHeading}>
        V. HOLDING, SUBSIDIARY & ASSOCIATE COMPANIES AND CSR DETAILS
      </p>
      <DynamicTable
        inputData={inputData}
        tables={tables}
        data={data}
        setTables={setTables}
        errors={tabErrors}
        setErrors={setTabErrors}
        disabled={disabled}
        hide={hide}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "associatedCompaniesAndCsrDoc",
          ml: 3,
          removeUpload,
        }}
      />

      {/* Section VI */}
      <p className={style.subHeading} style={{ marginTop: "1rem" }}>
        VI. CSR Details
      </p>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 600, fontSize: "16px", mt: 3 }}
      >
        24. a. Whether CSR is applicable as per section 135 of Companies Act,
        2013
      </Typography>
      <FormControl>
        <RadioGroup
          row
          value={csrApplicable}
          onChange={(e) => {
            const value = e.target.value;
            setCsrApplicable(value);
            if (value === "No") {
              setFormData((prev) => ({
                ...prev,
                turnover: "",
                netWorth: "",
              }));
              setErrors((prev) => ({
                ...prev,
                turnover: "",
                netWorth: "",
              }));
            }
          }}
          disabled={disabled}
          sx={{ marginLeft: "1.5rem" }}
        >
          <FormControlLabel
            value="Yes"
            control={<Radio disabled={disabled} />}
            label="Yes"
          />
          <FormControlLabel
            value="No"
            control={<Radio disabled={disabled} />}
            label="No"
          />
        </RadioGroup>
      </FormControl>

      {csrApplicable === "Yes" && (
        <Grid container spacing={2} sx={{ width: "98%", ml: 1.5 }}>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, fontSize: "16px", mt: 3 }}
            >
              b. Turnover (INR)
            </Typography>
            <TextField
              fullWidth
              size="small"
              disabled={disabled}
              placeholder="INR"
              value={formData.turnover}
              onChange={(e) => handleCsrInputChange("turnover", e.target.value)}
              error={!!errors.turnover}
              helperText={
                <Typography
                  variant="body2"
                  color="error"
                  style={{
                    lineHeight: "1.2",
                    margin: "2px 0",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                    marginLeft: "-10px",
                  }}
                >
                  {errors.turnover}
                </Typography>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, fontSize: "16px", mt: 3 }}
            >
              c. Net Worth (INR)
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="INR"
              disabled={disabled}
              value={formData.netWorth}
              onChange={(e) => handleCsrInputChange("netWorth", e.target.value)}
              error={!!errors.netWorth}
              helperText={
                <Typography
                  variant="body2"
                  color="error"
                  style={{
                    lineHeight: "1.2",
                    margin: "2px 0",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                    marginLeft: "-10px",
                  }}
                >
                  {errors.netWorth}
                </Typography>
              }
            />
          </Grid>
        </Grid>
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "csrDetailsDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ width: "97%", ml: 3 }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message} // Optional, since you're using <Alert> for the message
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity || "info"} // Ensure a default severity if undefined
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message || "No message provided"}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Holdings;
